// Hook responsável por gerenciar as tags de produtos DAF (busca, seleção e salvamento)
import { useState, useEffect } from 'react';

import {
  getAllTags,
  saveTags,
} from '../../../../../../services/produtosDAF/tagsProdutosDafService';
import { clearAllCache } from '../../../../../../utils/functions';
import { swalSave } from '../../../../../../utils/swal';
import { CACHE_KEY } from '../utils/constants';

export const useProdutoTags = (
  formProduto: any,
  setFormProduto: any,
  fetchData: any,
  fichaID: any,
) => {
  const [tagsProdutos, setTagsProdutos] = useState<
    { id: number; tag: string }[]
  >([]);

  // Estado mantém apenas IDs das tags selecionadas
  const [selectedTags, setSelectedTags] = useState<number[]>([]);

  // Offcanvas Tags
  const [showOffcanvasTags, setShowOffcanvasTags] = useState<boolean>(false);

  /**
   * Busca de tags disponíveis
   */
  useEffect(() => {
    const fetchTags = async () => {
      try {
        const tags = await getAllTags();

        // Move a tag "Nenhuma tag" (id 9999) para o início
        const tagsReordenadas = tags.sort((a, b) => {
          if (a.id === 9999) return -1;
          if (b.id === 9999) return 1;
          return 0;
        });

        setTagsProdutos(tagsReordenadas);
      } catch (error) {
        console.error('Erro ao obter tags:', error);
      }
    };

    fetchTags();
  }, []);

  /**
   * Inicialização das tags ao abrir o offcanvas
   */
  useEffect(() => {
    if (!showOffcanvasTags) return;

    const inicialTags =
      formProduto.tagsArray.length > 0
        ? formProduto.tagsArray.map((tag: { id: number }) => tag.id)
        : [9999]; // "Nenhuma tag"

    setSelectedTags(inicialTags);
  }, [showOffcanvasTags, formProduto.tagsArray]);

  /**
   * Atualiza seleção de tags
   */
  const handleTagsChange = (tagIds: number[]) => {
    setSelectedTags(tagIds);

    setFormProduto((prev: any) => ({
      ...prev,
      tagsArray: tagIds.includes(9999)
        ? []
        : tagsProdutos.filter((tag) => tagIds.includes(tag.id)),
    }));
  };

  /**
   * Salva as tags selecionadas
   */
  const handleCreateTags = async () => {
    try {
      const produtoDAFId = formProduto.id;
      const tagIds = selectedTags;

      await saveTags(produtoDAFId, tagIds);

      clearAllCache(CACHE_KEY);
      handleToggleOffcanvasTags();
      swalSave();
    } catch (error) {
      console.error('Erro ao salvar as tags:', error);
    }

    fetchData(fichaID);
  };

  /**
   * Abre / fecha offcanvas
   */
  const handleToggleOffcanvasTags = () => {
    setShowOffcanvasTags((show) => !show);
  };

  return {
    tagsProdutos,
    selectedTags,
    showOffcanvasTags,
    handleTagsChange,
    handleCreateTags,
    handleToggleOffcanvasTags,
  };
};
